<!--
 * @Author: pengyong
 * @Date: 2020-12-01 23:24:29
 * @LastEditors: pengyong
 * @LastEditTime: 2020-12-09 20:29:30
 * @Description:
 * @FilePath: /exhibit/src/views/user/components/HeadLine.vue
-->
<template>
    <div class="head-line">
        <div class="title">
            <slot></slot>
        </div>
        <div class="line"></div>
        <template v-if="showEdit">
            <div class="un-edit" @click="$emit('click-edit')" v-if="!isEdit">{{ $t("userCenter").edit }}</div>
            <div class="has-edit" v-else>
                <span class="del" @click="$emit('click-del')">{{ $t("userCenter").del }}({{ count }})</span>
                <span class="chooseAll" @click="clickAll">{{ !checkAll ? $t("userCenter").chooseAll : $t("userCenter").chooseAllCancel }}</span>
                <span class="mid-line"></span>
                <span class="cancel" @click="$emit('click-cancel')">{{ $t("userCenter").cancel }}</span>
            </div>
        </template>
    </div>
</template>

<script>
export default {
    props: {
        title: "",
        count: {
            type: Number,
            default: 0
        },
        showEdit: {
            type: Boolean,
            default: false
        },
        isEdit: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            checkAll: false
        };
    },
    methods: {
        clickAll() {
            this.checkAll = !this.checkAll;
            this.$emit("click-all", this.checkAll);
        }
    }
};
</script>

<style lang="scss" scoped>
.head-line {
    display: flex;
    align-items: center;
    font-size: 14px;
    padding-right: 60px;
    .title {
        color: rgba(9, 70, 140, 0.45);
        margin-right: 9px;
    }
    .line {
        height: 1px;
        flex: 1;
        background-color: #979797;
    }
    .un-edit {
        margin-left: 14px;
        color: #09468c;
        font-weight: 600;
        cursor: pointer;
    }
    .del {
        color: rgba(234, 103, 103, 1);
        font-weight: 600;
        margin-left: 11px;
        cursor: pointer;
    }
    .chooseAll {
        font-weight: 600;
        margin: 0 10px;
        cursor: pointer;
        color: rgba(9, 70, 140, 1);
    }
    .mid-line {
        height: 11px;
        width: 1px;
        background: rgba(151, 151, 151, 1);
        display: inline-block;
    }
    .cancel {
        margin-left: 11px;
        font-weight: 600;
        cursor: pointer;
        color: rgba(9, 70, 140, 1);
    }
}
</style>



// WEBPACK FOOTER //
// src/views/user/components/HeadLine.vue